<template>
  <section>
    <div id="#app">
      <iframe
        :src="src1"
        width="100%"
        height="800"
        frameborder="0"
        scrolling="auto"
        id="iframename"
        name="iframename"
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return { src1: "#" };
  },
  mounted() {
    let outletnumber__c = this.$route.query.outletnumber__c;
    console.log(outletnumber__c);
    let url =
      "https://report.51i.cc/WebReport/ReportServer?reportlet=eFPP%2Fpeiebystore.cpt&op=write&__cutpage__=v";
    if (outletnumber__c != null) {
      this.src1 = url + "&storename=" + outletnumber__c;
    } else {
      this.src1 = url;
    }
  }
};
</script>